import { ApiResponse } from "../utils/type/api-response.type"
import { CaptchaRespondBody } from "../utils/type/captcha.type"
import AppClient from "../utils/http-client/app-client"

export const requestCaptcha = (): ApiResponse<CaptchaRespondBody> => {
  return AppClient.post(`/api/v1/captcha/request`)
}

export const refreshCaptcha = (
  lastKey: string
): ApiResponse<CaptchaRespondBody> => {
  return AppClient.post(`/api/v1/captcha/refresh`, {
    lastKey,
  })
}
